import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarService {
  private _open = new BehaviorSubject<boolean>(false);
  open$ = this._open.asObservable();

  private _collapsed = new BehaviorSubject<boolean>(
    localStorage.getItem('sidebar_collapsed') === 'true'
  );
  collapsed$ = this._collapsed.asObservable();

  toggle(): void { this._open.next(!this._open.value); }
  close(): void { this._open.next(false); }

  toggleCollapsed(): void {
    const next = !this._collapsed.value;
    this._collapsed.next(next);
    localStorage.setItem('sidebar_collapsed', String(next));
  }

  get isCollapsed(): boolean { return this._collapsed.value; }
}
